import axios from "axios";
import { wmSign, wmAes, wm_aes_for_web } from "../../apiFunc/encrypt";
import { decrypt } from "../../apiFunc/decrypt";
import { EncryptRelay } from "../EncryptRelay/EncryptRelay";
import { GetTimeStamp } from "../../apiFunc/getDate";

const appURL = `${process.env.REACT_APP_APP_URL}/api`;
const oauthURL = `${process.env.REACT_APP_OAUTH_URL}/api`;
const appId = process.env.REACT_APP_ID;
const deviceUuid = process.env.REACT_APP_DEVICE_UUID;
const apiKey = process.env.REACT_APP_API_KEY;

const baseHeader = {
  "Content-Type": "application/json",
  "Accept-Language": "zh-TW",
  "app-id": appId,
  "device-uuid": deviceUuid,
};

/**Third party api */

// WS04 calling in final page
async function registerData(datatest) {
  console.log(datatest);
  const url = "app/add";
  const body = {
    Name: datatest.name,
    Mobile: datatest.mobile,
    Mobile_CT: null,
    Passwd: datatest.password,
    Birthday: datatest.birth,
    Telephone: datatest.phone,
    Telephone_Sep: datatest.extensionNumber,
    Telephone_Area: datatest.areaCode,
    Gender: datatest.sex,
    Country: null,
    Area: null,
    Location: datatest.address,
    District: datatest.district,
    ZipCode: null,
    City: datatest.city,
    Email: datatest.email,
    Educate: datatest.education,
    Profession: datatest.profession,
    Define4: datatest.applicationWay,
    Define5: datatest.interestActivities,
    Define6: datatest.gettingDiscountWay,
    CEntryWay: "6",
    S_NO: datatest.recommendCode, //喜好門市Code
    VerifyCode: datatest.verifyCode,
    RES_S_NO: datatest.recommendCode, //喜好門市
    VEHICLE: null,
    K: apiKey,
    F: "JSON",
    Q1: null,
  };
  console.log("body:", body);
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };

  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  const decryptResult = decrypt(results.data.payload);
  if (rcrm.RC === "C01") {
    return { RC: rcrm.RC, RM: rcrm.RM, result: JSON.parse(decryptResult) };
  } else {
    return { RC: rcrm.RC, RM: rcrm.RM, result: null };
  }
}

// WS06 calling in first page
async function checkMobile(datatest) {
  const url = "/app/checkMobile";
  const body = {
    Q1: datatest.mobile,
    K: apiKey,
    F: "JSON",
  };
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };
  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  const decryptResult = decrypt(results.data.payload);
  if (rcrm.RC === "C01") {
    return { RC: rcrm.RC, RM: rcrm.RM, result: JSON.parse(decryptResult) };
  } else {
    return { RC: rcrm.RC, RM: rcrm.RM, result: null };
  }
}

// WS07 calling in second page
async function checkEmail(datatest) {
  const url = "/app/checkEmail";
  const body = {
    Q1: datatest.email,
    K: apiKey,
    F: "JSON",
  };
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };
  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  const decryptResult = decrypt(results.data.payload);
  if (rcrm.RC === "C01") {
    return { RC: rcrm.RC, RM: rcrm.RM, result: JSON.parse(decryptResult) };
  } else {
    return { RC: rcrm.RC, RM: rcrm.RM, result: null };
  }
}

// WS52 calling in second page
async function verifyMobile() {
  const url = "app/verifyMobile";
  const body = {
    Q1: JSON.parse(sessionStorage.getItem("register1")).mobile,
    K: apiKey,
    F: "JSON",
  };
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };
  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  const decryptResult = decrypt(results.data.payload);
  if (rcrm.RC === "C01") {
    return { RC: rcrm.RC, RM: rcrm.RM, result: JSON.parse(decryptResult) };
  } else {
    return { RC: rcrm.RC, RM: rcrm.RM, result: null };
  }
}

export { registerData, checkEmail, verifyMobile, checkMobile };
